
import { createTranslations } from '../../i18n/types.ts';

export default createTranslations({
  en: {
    title: 'How do contracts work?',
    whatIsTitle: 'What is a contract?',
    whatIsDescription:
      'A contract is an exchange of several of your items for one new item. The value of the new item depends on the total value of the traded items.',
    howToUseTitle: 'How to execute a contract:',
    howToUseStep1: 'Tap "Select items" and pick 3 to 10 items',
    howToUseStep2: 'Below the crate you can see the minimum and maximum value of the prize',
    howToUseStep3: 'To remove an item, tap it inside the crate',
    howToUseStep4: 'Tap "Run contract" — the needle spins and stops on the prize value',
    rulesTitle: 'Rules:',
    rulesRule1: 'Minimum 3 items, maximum 10',
    rulesRule2: 'All selected items will be lost',
    rulesRule3: 'The new item can be either more or less valuable than the input sum',
  },
  ru: {
    title: 'Как работают контракты?',
    whatIsTitle: 'Что такое контракт?',
    whatIsDescription:
      'Контракт - это обмен нескольких твоих предметов на один новый. Стоимость нового предмета зависит от суммарной стоимости обмениваемых предметов.',
    howToUseTitle: 'Как выполнить контракт:',
    howToUseStep1: 'Нажми «Выбрать предметы» и выбери от 3 до 10 предметов',
    howToUseStep2: 'Под кейсом показаны минимальная и максимальная стоимость возможного приза',
    howToUseStep3: 'Чтобы убрать предмет — нажми на него в ящике',
    howToUseStep4: 'Нажми «Выполнить контракт» — стрелка прокрутится и остановится на цене приза',
    rulesTitle: 'Правила:',
    rulesRule1: 'Минимум 3 предмета, максимум 10',
    rulesRule2: 'Все выбранные предметы будут потеряны',
    rulesRule3: 'Новый предмет может быть как дороже, так и дешевле суммы входящих',
  },
  uz: {
    title: 'Kontraktlar qanday ishlaydi?',
    whatIsTitle: 'Kontrakt nima?',
    whatIsDescription:
      'Kontrakt - bu bir nechta buyumlaringizni bitta yangi buyumga almashtirishdir. Yangi buyumning qiymati almashtirilayotgan buyumlarning umumiy qiymatiga bogʻliq.',
    howToUseTitle: 'Kontraktni qanday bajarish:',
    howToUseStep1: "«Buyumlarni tanlash»ni bosing va 3 dan 10 tagacha buyum tanlang",
    howToUseStep2: 'Quti ostida mumkin boʻlgan yutuqning minimal va maksimal qiymati koʻrsatiladi',
    howToUseStep3: "Buyumni olib tashlash uchun uni qutida bosing",
    howToUseStep4: '«Kontraktni bajarish»ni bosing — strelka aylanib, yutuq qiymatida toʻxtaydi',
    rulesTitle: 'Qoidalar:',
    rulesRule1: 'Kamida 3 buyum, koʻpi bilan 10 ta',
    rulesRule2: 'Barcha tanlangan buyumlar yoʻqoladi',
    rulesRule3: 'Yangi buyum kirish summasidan qimmatroq yoki arzonroq boʻlishi mumkin',
  },
  fa: {
    title: 'قرارداد چطور کار می‌کند؟',
    whatIsTitle: 'قرارداد چیست؟',
    whatIsDescription:
      'قرارداد یعنی چند آیتمت را با یک آیتم تازه عوض کنی. ارزش آیتم تازه به مجموع ارزش آیتم‌هایی که می‌دهی بستگی دارد.',
    howToUseTitle: 'قرارداد را چطور ببندیم:',
    howToUseStep1: '«انتخاب آیتم» را بزن و 3 تا 10 آیتم انتخاب کن',
    howToUseStep2: 'زیر جعبه کمترین و بیشترین ارزش جایزه را می‌بینی',
    howToUseStep3: 'برای برداشتن یک آیتم، داخل جعبه رویش بزن',
    howToUseStep4: '«اجرای قرارداد» را بزن — عقربه می‌چرخد و روی ارزش جایزه می‌ایستد',
    rulesTitle: 'قوانین:',
    rulesRule1: 'حداقل 3 آیتم، حداکثر 10',
    rulesRule2: 'همه آیتم‌های انتخاب‌شده از بین می‌روند',
    rulesRule3: 'آیتم تازه می‌تواند از مجموع ورودی گران‌تر یا ارزان‌تر باشد',
  },
  pt: {
    title: 'Como funcionam os contratos?',
    whatIsTitle: 'O que é um contrato?',
    whatIsDescription:
      'Um contrato é a troca de vários itens seus por um item novo. O valor do item novo depende do valor total dos itens trocados.',
    howToUseTitle: 'Como executar um contrato:',
    howToUseStep1: 'Toque em “Escolher itens” e escolha de 3 a 10 itens',
    howToUseStep2: 'Abaixo da caixa aparecem o valor mínimo e o máximo do prêmio possível',
    howToUseStep3: 'Para tirar um item, toque nele dentro da caixa',
    howToUseStep4: 'Toque em “Executar contrato” — o ponteiro gira e para no valor do prêmio',
    rulesTitle: 'Regras:',
    rulesRule1: 'Mínimo de 3 itens, máximo de 10',
    rulesRule2: 'Todos os itens escolhidos serão perdidos',
    rulesRule3: 'O item novo pode valer mais ou menos do que a soma dos itens de entrada',
  },
  tr: {
    title: 'Kontratlar nasıl çalışır?',
    whatIsTitle: 'Kontrat nedir?',
    whatIsDescription:
      'Kontrat, birkaç eşyanı tek bir yeni eşyayla takas etmektir. Yeni eşyanın değeri, takas edilen eşyaların toplam değerine bağlıdır.',
    howToUseTitle: 'Kontrat nasıl çalıştırılır:',
    howToUseStep1: '“Eşya seç”e dokun ve 3 ile 10 arasında eşya seç',
    howToUseStep2: 'Kasanın altında olası ödülün minimum ve maksimum değeri gösterilir',
    howToUseStep3: 'Bir eşyayı çıkarmak için kutunun içinde ona dokun',
    howToUseStep4: '“Kontratı çalıştır”a dokun — ibre döner ve ödülün fiyatında durur',
    rulesTitle: 'Kurallar:',
    rulesRule1: 'En az 3, en fazla 10 eşya',
    rulesRule2: 'Seçilen tüm eşyalar kaybedilir',
    rulesRule3: 'Yeni eşya, giren eşyaların toplamından daha pahalı da daha ucuz da olabilir',
  },
  uk: {
    title: 'Як працюють контракти?',
    whatIsTitle: 'Що таке контракт?',
    whatIsDescription:
      'Контракт — це обмін кількох твоїх предметів на один новий. Вартість нового предмета залежить від сумарної вартості предметів, які ти обмінюєш.',
    howToUseTitle: 'Як виконати контракт:',
    howToUseStep1: 'Натисни «Вибрати предмети» й обери від 3 до 10 предметів',
    howToUseStep2: 'Під кейсом показано мінімальну й максимальну вартість можливого призу',
    howToUseStep3: 'Щоб прибрати предмет — натисни на нього в ящику',
    howToUseStep4: 'Натисни «Виконати контракт» — стрілка прокрутиться й зупиниться на ціні призу',
    rulesTitle: 'Правила:',
    rulesRule1: 'Мінімум 3 предмети, максимум 10',
    rulesRule2: 'Усі вибрані предмети буде втрачено',
    rulesRule3: 'Новий предмет може бути як дорожчим, так і дешевшим за суму вхідних',
  },
  de: {
    title: 'Wie funktionieren Contracts?',
    whatIsTitle: 'Was ist ein Contract?',
    whatIsDescription:
      'Ein Contract tauscht mehrere deiner Items gegen ein neues Item. Der Wert des neuen Items hängt vom Gesamtwert der eingetauschten Items ab.',
    howToUseTitle: 'So führst du einen Contract aus:',
    howToUseStep1: 'Tippe auf „Items wählen“ und wähle 3 bis 10 Items',
    howToUseStep2: 'Unter der Kiste siehst du den Mindest- und Höchstwert des möglichen Preises',
    howToUseStep3: 'Um ein Item zu entfernen, tippe es in der Kiste an',
    howToUseStep4: 'Tippe auf „Contract ausführen“ — der Zeiger dreht sich und bleibt auf dem Wert des Preises stehen',
    rulesTitle: 'Regeln:',
    rulesRule1: 'Mindestens 3 Items, höchstens 10',
    rulesRule2: 'Alle gewählten Items gehen verloren',
    rulesRule3: 'Das neue Item kann mehr oder weniger wert sein als die eingesetzten zusammen',
  },
  es: {
    title: '¿Cómo funcionan los contratos?',
    whatIsTitle: '¿Qué es un contrato?',
    whatIsDescription:
      'Un contrato es el cambio de varios de tus objetos por uno nuevo. El valor del objeto nuevo depende del valor total de los objetos que cambias.',
    howToUseTitle: 'Cómo hacer un contrato:',
    howToUseStep1: 'Pulsa «Elegir objetos» y selecciona de 3 a 10 objetos',
    howToUseStep2: 'Bajo la caja verás el valor mínimo y máximo del posible premio',
    howToUseStep3: 'Para quitar un objeto, púlsalo dentro de la caja',
    howToUseStep4: 'Pulsa «Hacer contrato»: la flecha girará y se detendrá en el valor del premio',
    rulesTitle: 'Reglas:',
    rulesRule1: 'Mínimo 3 objetos, máximo 10',
    rulesRule2: 'Todos los objetos elegidos se pierden',
    rulesRule3: 'El objeto nuevo puede valer más o menos que la suma de los que entregas',
  },
  pl: {
    title: 'Jak działają Kontrakty?',
    whatIsTitle: 'Czym jest kontrakt?',
    whatIsDescription:
      'Kontrakt to wymiana kilku twoich przedmiotów na jeden nowy. Wartość nowego przedmiotu zależy od łącznej wartości wymienianych przedmiotów.',
    howToUseTitle: 'Jak wykonać kontrakt:',
    howToUseStep1: 'Kliknij „Wybierz przedmioty” i wybierz od 3 do 10 przedmiotów',
    howToUseStep2: 'Pod skrzynką widać minimalną i maksymalną wartość możliwej nagrody',
    howToUseStep3: 'Żeby usunąć przedmiot, kliknij go w skrzynce',
    howToUseStep4: 'Kliknij „Wykonaj kontrakt” — strzałka się zakręci i zatrzyma na wartości nagrody',
    rulesTitle: 'Zasady:',
    rulesRule1: 'Minimum 3 przedmioty, maksimum 10',
    rulesRule2: 'Wszystkie wybrane przedmioty przepadną',
    rulesRule3: 'Nowy przedmiot może być wart więcej albo mniej niż suma wkładu',
  },
});
